<div *ngIf="canDisplayTile | async" class="card card-shadow d-flex flex-column">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">General Ledger Export</h3>
    <h6 class="flex-grow-1">
      Seamlessly post payroll information into your accounting system so that you can balance your
      account.
    </h6>
    <button
      (click)="clicked()"
      type="button"
      class="btn btn-primary float-end mt-auto align-self-end">
      Start Export
    </button>
  </div>
</div>
